module.exports = __webpack_public_path__ + "d73cf8a40c054a1c63acdd3ce203fc9d.webp";